namespace advisorop.services {
    `use strict`;

    export class RepGroupApi {

        readonly apiUrl = `/api/repgroup`;

        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }
        
        //getRepFeeGroups(companyGroupId: number, repGroupFeeOptions: number): ng.IHttpPromise<Array<domains.IRepFeeGroup>> {
        //    return this.$http.get("/api/servicer/getrepfeegroups/" + companyGroupId + "/" + repGroupFeeOptions);
        //};
        

        create(repFeeGroup: domains.IRepFeeGroup): ng.IHttpPromise<domains.IRepFeeGroup> {
            return this.$http.post(`${this.apiUrl}`, repFeeGroup);
        }

        update(repFeeGroup: domains.IRepFeeGroup): ng.IHttpPromise<domains.IRepFeeGroup> {
            return this.$http.put(`${this.apiUrl}`, repFeeGroup);
        }

        deleteRepGroup(id: number): ng.IHttpPromise<domains.IRepFeeGroup> {
            return this.$http.delete(`${this.apiUrl}/${id}`);
        }

        filterByOption(option: domains.RepGroupFeeOptions, companyGroupId?: number): ng.IHttpPromise<Array<domains.IRepFeeGroup>> {
            return this.$http.get(`${this.apiUrl}/filter?option=${option}&companyGroupId=${companyGroupId || null}`);
        }

        getForAccount(accountId: number): ng.IHttpPromise<Array<domains.IRepFeeGroup>> {
            return this.$http.get(`${this.apiUrl}/account/${accountId}`);
        }

        getById(id: number): ng.IHttpPromise<domains.IRepFeeGroup> {
            return this.$http.get(`${this.apiUrl}/${id}`);
        }

        search(searchTerm: string, option: domains.RepGroupFeeOptions): ng.IHttpPromise<domains.IRepFeeGroup[]> {
            return this.$http.get(`/api/repgroup/search?option=${option}&searchTerm=${searchTerm}`);
        }
    }
    angular.module(Constants.ADVOP_SERVICES).service("repGroupApi", RepGroupApi);
}